import {Lang} from 'yougile-lang'
import {Time, TimeInterval} from 'yougile-util'
import {
  DataObjectId,
  Hub,
  StickerType,
  Tag,
  TimerStickerEntry,
  TimerStickerValue,
  timerToInterval
} from 'yougile-model'
import {StickerContainerKey} from '../views-web/a-sticker-view'
import {ASystemStickerCtl} from './a-system-sticker-ctl'

export class TimerCtl extends ASystemStickerCtl<TimerStickerValue> {
  public requestedValue:
    | {taskId: DataObjectId; container: StickerContainerKey}
    | undefined

  public override onPinEmpty(
    task: Hub,
    _: Tag,
    container: StickerContainerKey
  ): void {
    this.requestedValue = {taskId: task.id, container}
  }

  public override get title(): string {
    return 'Timer'
  }

  public get type(): StickerType {
    return 'timer'
  }

  public displayedTitle(_: Tag): string {
    return Lang.msg.timer
  }

  public intervalFrom(timestamp: number): TimeInterval {
    return TimeInterval.fromDates(Time.now(), timestamp)
  }

  public formatTime(value: TimerStickerEntry): string {
    return TimerCtl.formatEntry(value, true)
  }

  public static formatEntry(
    value: TimerStickerEntry,
    forward: boolean
  ): string {
    const interval = timerToInterval(value, forward)
    if (!interval) {
      return ''
    }
    const noSeconds = Math.abs(interval.toSeconds()) >= 600
    const noMinutes = Math.abs(interval.toHours()) >= 25
    return interval.format(noSeconds, noMinutes)
  }
}
